module.exports = __webpack_public_path__ + "media/svg/nr-36029ddd.svg";